var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isVisible
    ? _c("div", { staticClass: "kept-items-unavailable" }, [
        _c("i", {
          staticClass: "fa fa-info-circle kept-items-unavailable__icon",
          attrs: { "aria-hidden": "true" }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "kept-items-unavailable__text" }, [
          _vm._v(
            "\n    " +
              _vm._s(
                _vm.$translate("Bigtex5::Template.keptItemsUnavailableNotice", {
                  count: _vm.count
                })
              ) +
              "\n  "
          )
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }